// src/api/messaging.js - COMPLETE UPDATED VERSION
import api from './config';

const messagingApi = {
  // Test endpoints
  publicTest: () => api.get('/messaging/public-test/'),
  sessionTest: () => api.get('/messaging/session-test/'),
  createTestMessages: () => api.post('/messaging/create-test-messages/'),
  
  // Message endpoints
  getMessages: (params) => api.get('/messaging/messages/', { params }),
  getMessage: (id) => api.get(`/messaging/messages/${id}/`),
  createMessage: (data) => {
    if (data instanceof FormData) {
      return api.post('/messaging/messages/', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.post('/messaging/messages/', data);
  },
  replyToMessage: (id, data) => {
    if (data instanceof FormData) {
      return api.post(`/messaging/messages/${id}/reply/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.post(`/messaging/messages/${id}/reply/`, data);
  },
  markAsRead: (id) => api.patch(`/messaging/messages/${id}/mark-read/`, {}),
  markAllAsRead: () => api.post('/messaging/mark-all-read/', {}),
  deleteMessage: (id) => api.delete(`/messaging/messages/${id}/`),
  
  // Stats endpoints
  getUnreadCount: () => api.get('/messaging/unread-count/'),
  getMessageStats: () => api.get('/messaging/stats/'),
  
  // User data endpoints - NEW UNIFIED ENDPOINT
  getMessagingUserData: () => api.get('/messaging/user-data/'),
  
  // Keep old endpoints for compatibility (optional)
  getUserOrders: () => api.get('/orders/user-orders/'),
  getUserPayments: () => api.get('/payments/user-payments/'),
  
  // Test API connection
  testApi: async () => {
    const results = {};
    const endpoints = [
      { name: 'Public Test', endpoint: '/messaging/public-test/' },
      { name: 'Session Test', endpoint: '/messaging/session-test/' },
      { name: 'Get Messages', endpoint: '/messaging/messages/' },
      { name: 'Unread Count', endpoint: '/messaging/unread-count/' },
      { name: 'Message Stats', endpoint: '/messaging/stats/' },
      { name: 'Messaging User Data', endpoint: '/messaging/user-data/' },  // NEW
      { name: 'User Orders', endpoint: '/orders/user-orders/' },
      { name: 'User Payments', endpoint: '/payments/user-payments/' }
    ];
    
    for (const item of endpoints) {
      try {
        const response = await api.get(item.endpoint);
        results[item.name] = {
          status: 'success',
          data: response.data,
          statusCode: 200
        };
      } catch (error) {
        results[item.name] = {
          status: error.response?.status === 404 ? 'warning' : 'error',
          error: error.message,
          statusCode: error.response?.status || 500,
          note: error.response?.status === 404 ? 'Endpoint not yet implemented' : undefined
        };
      }
    }
    return results;
  }
};

export { messagingApi };